import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import IcomoonReact from 'icomoon-react';

import iconSet from '../../../shared/images/teambuildr-selection.json';

const ModalContainer = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  position: relative;
`;

const IconCircle = styled('div')`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: #F5F5F5;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 24px;
`;

const ModalTitle = styled('div')`
  font-family: 'Nunito Sans';
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 16px;
  color: #444444;
`;

const ModalText = styled('div')`
  font-family: 'Nunito Sans';
  font-size: 16px;
  font-weight: 400;
  color: #666666;
  line-height: 1.5;
  max-width: 400px;
`;

const CloseButton = styled('div')`
  position: absolute;
  top: 0;
  right: 0;
  padding: 10px;
  cursor: pointer;
`;

const AboutExercisePropertiesModal = ({ closeModal }) => (
  <ModalContainer>
    <CloseButton onClick={closeModal}>
      <IcomoonReact
        iconSet={iconSet}
        size={15}
        icon='remove'
        color='grey'
      />
    </CloseButton>

    <IconCircle>
      <IcomoonReact
        iconSet={iconSet}
        size={32}
        icon='info2'
        color='#444444'
      />
    </IconCircle>

    <ModalTitle>
      About Exercise Properties
    </ModalTitle>

    <ModalText>
      Exercise properties allow you to customize and track different aspects of your workouts. 
      You can add and remove properties to match your training needs and goals.
    </ModalText>
  </ModalContainer>
);

AboutExercisePropertiesModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
};

export default AboutExercisePropertiesModal; 